/* ------------------------------------------------------------------
   RAVA - HERO VIDEO

   The banner section was uploaded with a single 1080p file at 7.2 Mbps
   and served it unchanged to every device. It was the heaviest thing
   on the site by a wide margin, and slow mobile pages cost twice over:
   worse ranking, and a worse Quality Score, which raises the cost per
   click on the ads pointing at this page.

   A compressed encode of the same footage now exists, so the source is
   pointed at that instead, on every device. Phones get the video back.

   Why this is done here rather than in the section settings: the
   compressed file was supplied as a plain CDN URL, and the section
   expects a Shopify file reference, which needs a permission this app
   does not hold. Swapping the source achieves the same thing.

   Guarded: it only rewrites the source when it is still the known heavy
   file. Change the video in the theme editor and this quietly does
   nothing, rather than overriding the new choice.

   To remove: delete this file and its line in theme.liquid, then set
   the compressed file as the section's video in the theme editor.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  // The oversized encode this replaces.
  var HEAVY = '9df9206b0c0f4055922204f8414af6e4';
  var LIGHT = 'https://cdn.shopify.com/videos/c/o/v/5fbdb71a9e384ae2a9276bc17f062cbc.mp4';

  function swapSource(video) {
    if (!video || video.dataset.ravaVideo === 'done') return;

    var sources = video.querySelectorAll('source');
    var matched = false;

    for (var i = 0; i < sources.length; i++) {
      var src = sources[i].getAttribute('src') || '';
      if (src.indexOf(HEAVY) === -1) continue;
      sources[i].setAttribute('src', LIGHT);
      sources[i].setAttribute('type', 'video/mp4');
      matched = true;
    }

    if (!matched) return;

    video.dataset.ravaVideo = 'done';
    try { video.load(); } catch (e) {}

    // load() cancels playback, and the banner relies on autoplay.
    var play = video.play();
    if (play && play.catch) {
      play.catch(function () {
        /* Autoplay refused, which happens when a phone is in low power
           mode. The poster frame stays up, which is the right fallback. */
      });
    }
  }

  function run() {
    var videos = document.querySelectorAll('.banner__video, .banner__media video');
    for (var i = 0; i < videos.length; i++) swapSource(videos[i]);
  }

  // As early as the element can exist, so the browser commits as few bytes
  // of the heavy file as possible, then again once parsing is done.
  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
